import * as t from "react";
import { useKnockClient as u } from "../../core/context/KnockProvider.mjs";
import "@knocklabs/client";
import "zustand/shallow";
import { feedProviderKey as d } from "../../core/utils.mjs";
import a from "../hooks/useNotifications.mjs";
import { useCreateNotificationStore as f } from "../hooks/useNotificationStore.mjs";
const i = t.createContext(void 0), F = ({
  feedId: e,
  children: c,
  defaultFeedOptions: r = {},
  colorMode: s = "light"
}) => {
  const o = u(), n = a(o, e, r), m = f(n);
  return /* @__PURE__ */ t.createElement(i.Provider, { key: d(o.userId, e, r), value: {
    knock: o,
    feedClient: n,
    useFeedStore: m,
    colorMode: s
  } }, c);
}, l = () => {
  const e = t.useContext(i);
  if (!e)
    throw new Error("useKnockFeed must be used within a KnockFeedProvider");
  return e;
};
export {
  F as KnockFeedProvider,
  l as useKnockFeed
};
//# sourceMappingURL=KnockFeedProvider.mjs.map
